import React, { Fragment, useEffect, useState, useRef } from "react";
import { useForm } from "react-hook-form";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { useDispatch, useSelector } from "react-redux";
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
import { MaterialReactTable } from "material-react-table";
import type {
  ColumnFiltersState,
  PaginationState,
} from "@tanstack/react-table";
import { PAGES } from "../../Constants/CommonConstants";
import { paginationQuery, handleSearch } from "../../utils/GlobalHelper";
import { getDate, setItemToStorage } from "../../utils/Helper";
import {
  SalonGetAction,
  SalonStatusAction,
  SalonDetailsAction,
  SalonDeleteAction,
} from "../../Redux/Action/SalonAction";
import { SalonApprovedStatusAction } from "../../Redux/Action/SalonAction";
import Swal from "sweetalert2";
import { StorageConstant, VALIDATION_MESSAGE } from "../../Constants/Constants";
import { BASE_URL, url } from "../../Config/Config";
import { LinkButtons } from "../FieldComponets/LinkButtons";
import { DashboardRedirectionAction } from "../../Redux/Action/CommonAction";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getDateFormat, getDateFormatData } from "../../utils/Helper";
import { toast } from "react-toastify";
import { useIntl, FormattedMessage } from "react-intl";
function Salon() {
  const intl = useIntl();
  const [data, setData] = useState<any>([]);

  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);

  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
  const [sorting, setSorting] = useState<any>(["DESC"]);
  const salonlist = useSelector((state: any) => state.SalonGetState);
  const salonStatus = useSelector((state: any) => state.SalonStatusGetState);
  const DashboardRedirectionStatedata = useSelector(
    (state: any) => state.DashboardRedirectionState,
  );
  const salondelete = useSelector((state: any) => state.SalonDeleteState);

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: PAGES?.pageIndex,
    pageSize: PAGES?.pageSize,
  });
  const [searchValue, setSearchValue] = useState("");
  const [rowCount, setRowCount] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [serachstatus, setSerachstatus] = useState<any>({});
  const handleFilterValue = (e: any) => {
    const { name, value } = e.target;
    setSerachstatus((prevStatus: any) => ({ ...prevStatus, [name]: value }));
  };
  // Table Coulmns
  useEffect(() => {
    const fetchData = async () => {
      if (!data?.length) {
        setLoading(true);
      } else {
        setIsRefetching(true);
      }
      try {
        const userStatus = DashboardRedirectionStatedata?.data?.status;

        let query: any = paginationQuery(
          pagination.pageIndex,
          pagination.pageSize,
          sorting,
          searchValue,
          columnFilters,
        );
        query.columnFilters.push({ id: "status", value: userStatus });
        query.subscription_status_filter =
          serachstatus?.subscription_status_filter ?? "";
        dispatch(DashboardRedirectionAction("RESET"));

        await dispatch(SalonGetAction(query));
      } catch (error) {
        setIsError(true);
        return;
      }
      setIsError(false);
      setLoading(false);
      setIsRefetching(false);
    };
    fetchData();
  }, [
    columnFilters,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    salonStatus?.loading,
    salondelete?.status,
    serachstatus,
  ]);
  useEffect(() => {
    setData(salonlist?.data?.data?.rows);
    setRowCount(salonlist?.data?.data?.count);
  }, [salonlist?.data]);

  const handleChangeStatus = (data: any) => {
    const senddata = {
      status_id: data.id,
      status: data.status == "1" ? 0 : 1,
    };
    dispatch(SalonStatusAction(senddata));
  };
  const handleDeleteSalon = async (e: any) => {
    Swal.fire({
      title: VALIDATION_MESSAGE?.ARE_YOU_SURE,
      text: VALIDATION_MESSAGE?.ARE_YOU_DELETE_ANY,
      icon: "warning",
      // showCancelButton: true,
      confirmButtonColor: "#31CE36",
      cancelButtonColor: "#d33",
      showDenyButton: true,
      denyButtonText: intl.formatMessage({ id: "no" }),
      confirmButtonText: intl.formatMessage({ id: "yes" }),
    }).then(async (result) => {
      if (result.isConfirmed) {
        console.log(result, "hgggggdgdgdgdgdgdgd");
        const data = {
          salon_id: e?.id,
        };
        dispatch(SalonDeleteAction(data));
      }
    });
  };

  const showPopu = () => {
    toast.error(intl.formatMessage({ id: "cannot_edit_salon_until_approved" }));
  };

  const columns: any = [
    {
      accessorKey: "S.NO",
      header: intl.formatMessage({ id: "s_no" }),
      accessorFn: (row: Object, index: number) => {
        const currentPage = pagination.pageIndex + 1 || 1; // Assuming current page number, default to 1 if not provided
        const itemsPerPage = pagination.pageSize || 10; // Assuming items per page, default to 10 if not provided
        const startIndex = (currentPage - 1) * itemsPerPage;
        const serialNumber = startIndex + index + 1;
        return serialNumber;
      },
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
      size: 50,
    },
    {
      accessorKey: "id",
      header: intl.formatMessage({ id: "salon_id" }),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: "salon_name",
      header: intl.formatMessage({ id: "salon_name" }),
      accessorFn: (row: { salon_name: any }) =>
        row.salon_name == null
          ? intl.formatMessage({ id: "no_salon_name" })
          : row.salon_name,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: "email",
      header: intl.formatMessage({ id: "email" }),
      accessorFn: (row: { email: any }) =>
        row.email == null ? intl.formatMessage({ id: "no_email" }) : row.email,
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      header: intl.formatMessage({ id: "subscription_plan" }),
      accessorFn: (row: any) =>
        row.subscription_plan_name ||
        row.subscription_plan_type ||
        "—",
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      header: intl.formatMessage({ id: "subscription_plan_status" }),
      accessorFn: (row: any) => row.subscription_plan_status || "—",
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      header: intl.formatMessage({ id: "subscription_active_date" }),
      accessorFn: (row: any) =>
        row.subscription_active_date
          ? getDate(row.subscription_active_date)
          : "—",
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      header: intl.formatMessage({ id: "subscription_end_date" }),
      accessorFn: (row: any) =>
        row.subscription_expires_at
          ? getDate(row.subscription_expires_at)
          : "—",
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: "phone_number",
      header: intl.formatMessage({ id: "mobile_number" }),
      accessorFn: (row: any) =>
        row.phone_number == null
          ? intl.formatMessage({ id: "no_mobile" })
          : `${row?.phone_country_code} ${row.phone_number}`,

      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: "location",
      header: intl.formatMessage({ id: "location" }),
      accessorFn: (row: { location: any }) =>
        row.location == null
          ? intl.formatMessage({ id: "no_location" })
          : row.location,

      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: "total_booking",
      header: intl.formatMessage({ id: "total_booking" }),
      accessorFn: (row: { total_booking: any; id: any }) => {
        if (row.total_booking > 0) {
          return (
            <Link
              // to={`/booking-list?salon_id=${row.id}`}
              to={"/booking-list"}
              onClick={() =>
                dispatch(DashboardRedirectionAction({ salon_id: row?.id }))
              }
            >
              {row.total_booking}
            </Link>
          );
        } else {
          return 0;
        }
      },

      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: "total_services",
      header: intl.formatMessage({ id: "total_services" }),
      // accessorFn: (row: { total_services: any }) =>
      //   row.location == null ? "No Location" : row.location,

      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: "description",
      header: intl.formatMessage({ id: "description" }),
      accessorFn: (row: { description: any }) =>
        row.description == null
          ? intl.formatMessage({ id: "no_description" })
          : row.description,

      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      accessorKey: "is_approved",
      header: intl.formatMessage({ id: "approved_status" }),
      accessorFn: (row: { is_approved: any }) => {
        if (row.is_approved === 0) {
          return (
            <a type="button" className="btn btn-warning">
              <FormattedMessage id="pending" />
            </a>
          );
        } else if (row.is_approved === 1) {
          return (
            <a type="button" className="btn btn-success">
              <FormattedMessage id="approved" />
            </a>
          );
        } else if (row.is_approved === 2) {
          return (
            <a type="button" className="btn btn-danger">
              <FormattedMessage id="rejected" />
            </a>
          );
        } else if (row.is_approved === 3) {
          return (
            <a type="button" className="btn btn-info">
              <FormattedMessage id="resubmit" />
            </a>
          );
        } else {
          return null; // Or some default case if needed
        }
      },
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },

    {
      accessorKey: "created_at",
      header: intl.formatMessage({ id: "created_at" }),
      accessorFn: (row: { created_at: any }) => getDate(row.created_at),
      // dateSetting: { locale: "en-GB" },
      size: 100,
      filterVariant: "date",
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      header: intl.formatMessage({ id: "status" }),
      size: 50,
      accessorFn: (row: { id: any; status: number }) => (
        <>
          <div className="btn-group action-btn-table">
            <ul style={{ listStyleType: "none", marginLeft: "-24px" }}>
              <label className="switch">
                <input
                  className=" profile-approve-dropdown"
                  type="checkbox"
                  checked={row.status == 1}
                  onChange={() => handleChangeStatus(row)}
                />
                <span className="slider round"></span>
              </label>
            </ul>
          </div>
        </>
      ),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
    {
      header: intl.formatMessage({ id: "action" }),
      size: 30,
      accessorFn: (row: { id: any; is_approved: any }) => (
        <>
          <div className="btn-group action-btn-table">
            <ul style={{ listStyleType: "none", marginLeft: "-24px" }}>
              <span>
                <LinkButtons
                  pageLink={`salon-details`}
                  pageID={row?.id}
                  showEdit={false}
                  showView={true}
                  showDelete={false}
                />
              </span>
            </ul>
            <ul style={{ listStyleType: "none", marginLeft: "-10px" }}>
              {row?.is_approved == "1" ? (
                <span>
                  <LinkButtons
                    pageLink={`salon-edit`}
                    pageID={row?.id}
                    showEdit={true}
                    showView={false}
                    showDelete={false}
                  />
                </span>
              ) : (
                <span onClick={() => showPopu()}>
                  <LinkButtons
                    pageLink={`salon-edit`}
                    pageID={row?.id}
                    showEdit={false}
                    showView={false}
                    showDelete={false}
                    showEdit_disable={true}
                  />
                </span>
              )}
            </ul>
            <ul style={{ listStyleType: "none", marginLeft: "-10px" }}>
              <a
                className="btn btn-danger-delete text-white"
                onClick={() => handleDeleteSalon(row)}
              >
                <i
                  className="fas fa-trash-alt"
                  title={intl.formatMessage({ id: "delete" })}
                />
              </a>
            </ul>
          </div>
        </>
      ),
      enableSorting: false,
      enableColumnOrdering: false,
      enableColumnDragging: false,
      enableColumnFilter: false,
    },
  ];

  const handeldate = (e: any) => {
    const formattedDate = moment(e).format("YYYY-MM-DD");
    setStartDate(formattedDate);
  };

  const handelEnddate = (e: any) => {
    const formattedDate = moment(e).format("YYYY-MM-DD");
    setEndDate(formattedDate);
  };
  const resetSearchfilter = () => {
    setStartDate("");
    setEndDate("");
    setSearchValue("");
    setSerachstatus({});
    if (formRef.current) {
      formRef.current.reset();
    }
    const columnFilters = [
      { id: "start_date", value: "" },
      { id: "end_date", value: "" },
      { id: "search", value: "" },
      { id: "status", value: "" },
    ];
    setColumnFilters(columnFilters);
  };
  const handleserach = (e: any) => {
    e.preventDefault();
    setLoading(true);
    const columnFilters = [
      { id: "start_date", value: startDate.trim() },
      { id: "end_date", value: endDate.trim() },
      { id: "search", value: searchValue.trim() },
      { id: "status", value: serachstatus?.status },
      { id: "profile_status", value: serachstatus?.profile_status },
    ];
    setColumnFilters(columnFilters);
  };

  return (
    <Fragment>
      {loading || salonlist?.loading || salondelete?.loading ? (
        <Spinner />
      ) : (
        ""
      )}
      <PageLayout
        title={<FormattedMessage id="salon_management" />}
        breadcrumbs={{
          secLast: {
            link: "/salon-list",
            name: <FormattedMessage id="salon_management" />,
          },
        }}
        buttons={[
          {
            url: "/class-add",
            className: "btn btn-primary",
            text: "+ Add Sponsors",
            show: false,
          }, // This button will be shown
        ]}
      >
        <form ref={formRef} onSubmit={handleserach}>
          <div className="row gy-3 mt-3 mb-4">
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label><FormattedMessage id="start_date" /></label>
              <DatePicker
                className="form-control"
                placeholderText={intl.formatMessage({ id: "date_placeholder" })}
                value={startDate ? getDateFormatData(startDate) : ""}
                onChange={(e) => handeldate(e)}
                onKeyDown={(e) => e.preventDefault()}
              />
            </div>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label><FormattedMessage id="end_date" /></label>
              <DatePicker
                className="form-control"
                placeholderText={intl.formatMessage({ id: "date_placeholder" })}
                value={endDate ? getDateFormatData(endDate) : ""}
                onChange={(e) => handelEnddate(e)}
                minDate={new Date(startDate)}
                onKeyDown={(e) => e.preventDefault()}
              />
            </div>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label><FormattedMessage id="all_salon" /></label>
              <select
                className="form-select shadow-none"
                name="status"
                id="cars"
                onChange={handleFilterValue}
              >
                <option value="">{intl.formatMessage({ id: "all_salon" })}</option>
                <option value="1">{intl.formatMessage({ id: "active_salon" })}</option>
                <option value="0">{intl.formatMessage({ id: "deactive_salon" })}</option>
              </select>
            </div>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label><FormattedMessage id="profile_status" /></label>
              <select
                className="form-select shadow-none"
                name="profile_status"
                id="cars"
                onChange={handleFilterValue}
              >
                <option value="">{intl.formatMessage({ id: "all_profile" })}</option>
                <option value="1">{intl.formatMessage({ id: "approved_profile" })}</option>
                <option value="0">{intl.formatMessage({ id: "pending_profile" })}</option>
                <option value="2">{intl.formatMessage({ id: "rejected_profile" })}</option>
              </select>
            </div>
            <div className="col-md-4 col-lg-4 col-xl-3">
              <label><FormattedMessage id="subscription_plan_status" /></label>
              <select
                className="form-select shadow-none"
                name="subscription_status_filter"
                onChange={handleFilterValue}
                value={serachstatus?.subscription_status_filter ?? ""}
              >
                <option value="">{intl.formatMessage({ id: "all_subscriptions" })}</option>
                <option value="active">{intl.formatMessage({ id: "active" })}</option>
                <option value="inactive">{intl.formatMessage({ id: "inactive" })}</option>
                <option value="suspended">{intl.formatMessage({ id: "suspended" })}</option>
                <option value="expired">{intl.formatMessage({ id: "expired" })}</option>
              </select>
            </div>
            <div className="row gy-3 mb-0">
              <div className="col-md-6 col-lg-4 col-xl-3">
                <div className="input-group w-100">
                  <div className="input-group">
                    <span
                      className="input-group-text fa-solid fa-magnifying-glass "
                      id="basic-addon1"
                    >
                      {" "}
                      <i className="fas fa-search"></i>
                    </span>
                    <input
                      type="text"
                      id="saerchId"
                      className="form-control m-0"
                      placeholder={intl.formatMessage({ id: "search_by_name" })}
                      onChange={(e) => setSearchValue(e.target.value.trim())}
                    />
                  </div>
                </div>
              </div>
              <div className="col-6">
                <button className="btn theme-bg text-white me-2">
                  <FormattedMessage id="filter" />
                </button>
                <button
                  className="btn btn-success"
                  onClick={() => resetSearchfilter()}
                >
                  <FormattedMessage id="reset" />
                </button>
              </div>
            </div>
          </div>
        </form>
        {data && (
          <MaterialReactTable
            columns={columns}
            data={data}
            enableGlobalFilter={false}
            enableHiding={false}
            enableColumnFilters={false}
            enableDensityToggle={false}
            enableColumnActions={false}
            enableFullScreenToggle={false}
            positionToolbarAlertBanner="top"
            initialState={{ showColumnFilters: false }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={
              isError
                ? {
                    color: "error",
                    children: intl.formatMessage({ id: "error_loading_data" }),
                  }
                : undefined
            }
            muiSearchTextFieldProps={{
              placeholder: intl.formatMessage({ id: "search_from_name" }),
            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={(value: any) =>
              handleSearch(
                value,
                setIsError,
                setLoading,
                setIsRefetching,
                setSearchValue,
              )
            }
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        )}
        <ToastDefault />
      </PageLayout>
    </Fragment>
  );
}

export default Salon;
